import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { FormGroup, Button, Col, Row, FormControl, ControlLabel} from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import debounce from "lodash/debounce";
import PerformancesService from "../../../services/PerformancesService";
import AdminService from "../../../services/AdminService";
import HandleError from "../../../services/HandleError";
import LoaderInline from "../../helpers/LoaderInline";
import InlineError from "../../messages/InlineError";

class PerformanceCreateForm extends Component {

    state = {
    	selectedEmployee: null,
    	savePerformanceLoading: false,
    	isLoadingUsers: true,
    	formData:{},
    	users: [],
    	errors: {}
    }

    onChange = (e) => { this.setState({ formData: {...this.state.formData, [e.target.name]: e.target.value} }); }

	onAsyncChange = (option, name, selected) => { 
		if (option !== null) {
			this.setState({ [selected]: option, formData: { ...this.state.formData, [name]: option.value || "" } });
		} else {
			this.setState({ [selected]: null, formData: { ...this.state.formData, [name]: null } });
		}
	}

	onSubmit = (e) => {
		e.preventDefault();
		this.setState({savePerformanceLoading: true, errors: {}});
		this.createPerformanceService.store(this.state.formData).then((res) => {
			this.setState({savePerformanceLoading: false});
			NotificationManager.success("Performance created.","Success!");
			this.props.history.push("/performances");	 
		}).catch((err) => {
			this.setState({savePerformanceLoading: false});
			HandleError(err, this);
		});
	}

	handleSearchEmployee = (input = null, callback) => {
		if (!input || !input.replace(/\s/g, "").length) {
		 callback(null, { complete: true });
		 return;
		}
		this.employeeCallback(input, callback);
	}
	
	employeeCallback = debounce((input, callback) => {
		this.usersAdminService.search(input).then((res) => {
			callback(null, {options: res.data.map((item)=> ({label: item.full_name, value: item.id})) , complete: true });
		}).catch((err) => {
			HandleError(err);
			callback(null, { complete: true });
		});
	}, 200);

	usersAdminService = new AdminService(this,"users");     
	createPerformanceService = new PerformancesService(this);

	render() {
		const { savePerformanceLoading, formData, errors, selectedEmployee } = this.state;

		return (
    		<React.Fragment>
    			<Row>
					<form onSubmit={this.onSubmit}>
    					<Col md={4} sm={12}>
							<span className="column-title">Performance details</span>								
							<FormGroup validationState={errors.user_id && "error"} >
								<ControlLabel>User</ControlLabel>	
								<Select.Async
									onChange={(option) => { this.onAsyncChange(option, "user_id", "selectedEmployee"); }}
									name="user_id"
									placeholder="Search user"
									value={selectedEmployee}
									loadOptions={this.handleSearchEmployee }
									multi={false}
								/>
								{ errors.user_id && <InlineError text={errors.user_id} /> }
							</FormGroup>

							<FormGroup validationState={errors.value && "error"}>
								<ControlLabel>Performance value</ControlLabel>                                  
								<FormControl type="text" name="value" placeholder="Enter value" value={formData.value || ""} onChange={this.onChange}/>						
								{errors.value && <InlineError text={errors.value} />}								                                							
							</FormGroup>

							<Button className="btn-crud" bsStyle="primary" disabled={savePerformanceLoading} type="submit">{savePerformanceLoading?"Saving...":"Save"}</Button> 
							{ savePerformanceLoading ? <LoaderInline width="30" height="30" color="#2196f3"/> :  null }																												
    					</Col>	
					</form>						
    			</Row>
    		</React.Fragment>
    	);
	}
}
PerformanceCreateForm.propTypes = {
	history: PropTypes.shape({
		push: PropTypes.func.isRequired
	}).isRequired
};
export default PerformanceCreateForm;


// WEBPACK FOOTER //
// ./src/components/forms/performances/PerformanceCreateForm.js